export default {
  nav: {
    brand: 'Imagenx',
    dashboard: 'Tableau de bord',
    myImages: 'Mes images',
    history: 'Historique',
    account: 'Mon compte',
    support: 'Support',
    admin: 'Admin',
    logout: 'Déconnexion',
    credits: '{count} crédit | {count} crédits',
    creditsTitle: 'Votre solde de crédits — cliquez pour recharger',
    creditsLow: 'Solde bas : plus assez de crédits pour une image. Cliquez pour recharger.'
  },
  common: {
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    rename: 'Renommer',
    loading: 'Chargement...',
    close: 'Fermer',
    backToHome: 'Retour à l\'accueil',
    status: {
      pending: 'En attente',
      processing: 'En cours',
      completed: 'Terminé',
      failed: 'Échec'
    }
  },
  dashboard: {
    title: 'Générer des images',
    mainPromptLabel: 'Prompt principal (style, ambiance, format)',
    loadPreset: 'Charger un préréglage...',
    savePreset: 'Enregistrer comme préréglage',
    deletePreset: 'Supprimer le préréglage',
    mainPromptPlaceholder: 'ex. Photographie cinématographique, éclairage dramatique, 8k, ultra détaillé...',
    aspectRatio: 'Format',
    aspectSquare: '1:1 (Carré)',
    aspectLandscape: '16:9 (Paysage)',
    aspectPortrait: '9:16 (Portrait)',
    type: 'Type',
    none: 'Aucun',
    typePhotography: 'Photographie',
    typeIllustration: 'Illustration',
    type3dRender: 'Rendu 3D',
    typeDigitalArt: 'Art numérique',
    typeOilPainting: 'Peinture à l\'huile',
    typeWatercolor: 'Aquarelle',
    typePencilSketch: 'Croquis au crayon',
    typePixelArt: 'Pixel art',
    realism: 'Réalisme',
    realismPhotorealistic: 'Photoréaliste',
    realismHyperrealistic: 'Hyperréaliste',
    realismStylized: 'Stylisé',
    realismAbstract: 'Abstrait',
    realismCartoon: 'Dessin animé',
    lighting: 'Éclairage',
    lightingNatural: 'Lumière naturelle',
    lightingStudio: 'Éclairage studio',
    lightingDramatic: 'Éclairage dramatique',
    lightingGoldenHour: 'Heure dorée',
    lightingNeon: 'Lueur néon',
    lightingSoft: 'Diffus et doux',
    lightingBacklit: 'Contre-jour',
    lightingLowKey: 'Ton bas',
    mood: 'Ambiance',
    moodCinematic: 'Cinématographique',
    moodDreamy: 'Onirique',
    moodDarkMoody: 'Sombre et mystérieux',
    moodVibrant: 'Vibrant',
    moodMinimalist: 'Minimaliste',
    moodVintage: 'Vintage',
    moodFuturistic: 'Futuriste',
    coherence: 'Cohérence',
    coherenceNone: 'Aucune',
    coherenceStyle: 'Même style',
    coherenceVariation: 'Même scène',
    coherenceHint: {
      none: 'Seul le prompt principal relie les images entre elles',
      style: 'La 1re image sert de modèle de style, chaque scène reste différente',
      variation: 'Les images suivantes reprennent la 1re et n\'en changent que le détail demandé'
    },
    coherenceNeedsTwo: 'À partir de 2 images',
    referenceBadge: 'Référence',
    savePresetTitle: 'Enregistrer le préréglage',
    presetNamePlaceholder: 'Nom du préréglage...',
    imagePlaceholder: 'Image {n} - Décrivez cette image en particulier...',
    remove: 'Supprimer',
    addImage: '+ Ajouter une image',
    generating: 'Génération en cours...',
    generateMany: 'Générer {count} image | Générer {count} images',
    dismiss: 'Fermer',
    results: 'Résultats',
    downloading: 'Téléchargement...',
    downloadSelected: 'Télécharger la sélection',
    downloadSelectedCount: 'Télécharger {count} sélectionnée(s)',
    saving: 'Enregistrement...',
    saveSelected: 'Enregistrer la sélection',
    saveSelectedCount: 'Enregistrer {count} sélectionnée(s)',
    queued: 'En attente',
    failed: 'Échec',
    saveToFolder: 'Enregistrer dans un dossier',
    newFolderPlaceholder: 'Nom du nouveau dossier',
    newFolder: 'Nouveau dossier',
    imageCount: '{count} image | {count} images'
  },
  history: {
    title: 'Historique de génération',
    empty: 'Aucune génération pour le moment.',
    createFirst: 'Créer votre premier lot',
    imagesCount: '{count} image | {count} images',
    noImage: 'Pas d\'image'
  },
  myImages: {
    title: 'Mes images',
    rename: 'Renommer',
    deleteFolder: 'Supprimer le dossier',
    empty: 'Aucune image enregistrée pour le moment.',
    generateFirst: 'Générer des images d\'abord',
    folderEmpty: 'Ce dossier est vide.',
    imagesCount: '{count} image | {count} images',
    downloadImage: 'Télécharger l\'image',
    deleteImage: 'Supprimer l\'image',
    clickToEdit: 'Cliquer pour modifier',
    renameFolderTitle: 'Renommer le dossier',
    confirmDeleteFolder: 'Supprimer ce dossier et toutes ses images ?'
  },
  auth: {
    signInSubtitle: 'Connectez-vous à votre compte',
    createSubtitle: 'Créez votre compte',
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    minChars: 'Min. 6 caractères',
    signingIn: 'Connexion...',
    signIn: 'Se connecter',
    creatingAccount: 'Création du compte...',
    createAccount: 'Créer un compte',
    noAccount: 'Vous n\'avez pas de compte ?',
    signUp: 'S\'inscrire',
    hasAccount: 'Vous avez déjà un compte ?',
    forgotPassword: 'Mot de passe oublié ?',
    forgotPasswordTitle: 'Mot de passe oublié',
    forgotPasswordSubtitle: 'Recevez un lien de réinitialisation par email',
    sendResetLink: 'Envoyer le lien',
    sending: 'Envoi...',
    forgotEmailSent: 'Si cet email existe, des instructions de réinitialisation ont été envoyées.',
    resetPasswordTitle: 'Nouveau mot de passe',
    resetPasswordSubtitle: 'Choisissez un nouveau mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    resetPasswordButton: 'Réinitialiser le mot de passe',
    resetting: 'Réinitialisation...',
    resetSuccess: 'Mot de passe mis à jour. Vous pouvez maintenant vous connecter.',
    backToLogin: 'Retour à la connexion',
    checkEmailTitle: 'Vérifiez votre boîte mail',
    checkEmailBody: 'Un email de confirmation a été envoyé à {email}. Cliquez sur le lien qu\'il contient pour activer votre compte et vos crédits offerts.',
    checkEmailResent: 'Ce compte existait déjà sans avoir été confirmé : nous vous avons simplement renvoyé l\'email. Connectez-vous avec le mot de passe choisi lors de votre première inscription (ou utilisez « mot de passe oublié »).',
    confirmingEmail: 'Confirmation en cours...',
    confirmSuccess: 'Email confirmé ! Vous pouvez maintenant vous connecter.',
    confirmError: 'Ce lien de confirmation est invalide ou a expiré.',
    resendConfirmation: 'Renvoyer l\'email de confirmation',
    resendSuccess: 'Si ce compte existe et n\'est pas encore confirmé, un nouvel email a été envoyé.',
    unconfirmedError: 'Confirmez votre email avant de vous connecter.'
  },
  landing: {
    hero: {
      badge: 'Génération d\'images IA par lots',
      title: 'Un prompt principal. Plusieurs images cohérentes.',
      subtitle: 'ImageNX génère plusieurs images IA à la fois à partir d\'un prompt principal partagé et d\'un prompt propre à chaque image. Rapide, cohérent, avec des options à cocher plutôt que du jargon, et paiement à l\'usage sans abonnement.',
      ctaPrimary: 'Créer un compte gratuit',
      ctaSecondary: 'Se connecter',
      creditsNote: '80 crédits offerts à l\'inscription, sans carte bancaire.'
    },
    howItWorks: {
      title: 'Comment ça marche',
      subtitle: 'Le même mécanisme que le formulaire de génération : un prompt principal, un prompt par image.',
      step1Title: '1. Un prompt principal',
      step1Body: 'Décrivez le style, l\'ambiance et l\'éclairage partagés par toutes les images — ou choisissez-les dans des menus déroulants simples, sans connaître le jargon technique.',
      step2Title: '2. Un prompt par image',
      step2Body: 'Ajoutez autant d\'images que nécessaire, chacune avec son propre sujet.',
      step3Title: '3. Un lot cohérent',
      step3Body: 'ImageNX génère toutes les images en parallèle, avec un style visuel homogène.'
    },
    features: {
      title: 'Pourquoi ImageNX',
      speedTitle: 'Rapide',
      speedBody: 'Générez plusieurs images en un seul lot au lieu de les lancer une par une.',
      coherenceTitle: 'Cohérent',
      coherenceBody: 'Le prompt principal partagé garantit un style homogène sur tout le lot.',
      simpleTitle: 'Sans jargon',
      simpleBody: 'Des menus déroulants pour le format, l\'éclairage, le style graphique — plus besoin de connaître "ambient light" ou "3D cel shading".',
      payAsYouGoTitle: 'Payez à l\'usage',
      payAsYouGoBody: 'Pas d\'abonnement : rechargez des crédits et utilisez-les seulement quand vous générez des images.',
      agentsTitle: 'Connectez vos agents IA',
      agentsBody: 'Une API avec authentification par token pour brancher Claude Code, Claude Desktop ou vos propres scripts, avec un skill dédié fourni pour démarrer en quelques minutes.'
    },
    gallery: {
      title: 'Un prompt principal, plusieurs images',
      subtitle: 'Deux lots générés d\'un seul coup avec le mode « Même style » : la première image sert de référence visuelle, les suivantes en reprennent l\'univers sans en copier la scène.',
      setALabel: 'Photographie cinématographique',
      setBLabel: 'Affiche vintage',
      referenceBadge: 'Référence'
    },
    pricing: {
      title: 'Payez à l\'usage',
      body: 'Pas d\'abonnement, pas d\'engagement. Rechargez des crédits et utilisez-les au fil de vos générations.',
      trialTitle: '80 crédits offerts',
      trialBody: 'Testez ImageNX gratuitement dès la création de votre compte, sans carte bancaire — de quoi générer une dizaine d\'images.'
    },
    footer: {
      tagline: 'Génération d\'images IA par lots, cohérente et sans effort.',
      loginLink: 'Connexion',
      registerLink: 'Créer un compte',
      copyright: '© {year} ImageNX',
      legalMentions: 'Mentions légales',
      legalPrivacy: 'Confidentialité',
      legalTerms: 'CGU/CGV',
      builtBy: 'Développé par'
    }
  },
  account: {
    title: 'Mon compte',
    profile: {
      title: 'Profil',
      nameLabel: 'Nom',
      emailLabel: 'Email',
      currentPasswordLabel: 'Mot de passe actuel',
      newPasswordLabel: 'Nouveau mot de passe',
      newPasswordPlaceholder: 'Laisser vide pour ne pas changer',
      passwordConfirmationLabel: 'Confirmer le nouveau mot de passe',
      saveSecurity: 'Mettre à jour',
      securityUpdated: 'Informations mises à jour.'
    },
    credits: {
      title: 'Crédits',
      topupTitle: 'Recharger des crédits',
      creditsCount: '{count} crédit | {count} crédits'
    },
    subscription: {
      title: 'Abonnement',
      pitch: 'Abonnez-vous pour 5€/mois et recevez 600 crédits chaque mois, sans engagement.',
      subscribeButton: "S'abonner — 5€/mois pour 600 crédits",
      manageButton: 'Gérer mon abonnement',
      billingHistory: 'Voir mon historique de facturation',
      renewsOn: 'renouvellement le {date}',
      cancelingOn: 'se termine le {date}',
      status: {
        active: 'Abonnement actif',
        trialing: "Période d'essai en cours",
        past_due: 'Paiement en retard',
        canceled: 'Abonnement résilié'
      }
    },
    history: {
      title: 'Historique des crédits',
      empty: 'Aucun mouvement pour le moment.',
      balance: 'solde : {balance}',
      reasons: {
        trialGrant: "Crédits d'essai offerts",
        generationDebit: 'Génération d\'images',
        generationRefund: 'Remboursement (échec de génération)',
        topupPurchase: 'Recharge de crédits',
        subscriptionGrant: "Crédits d'abonnement",
        adminAdjustment: 'Ajustement manuel'
      }
    },
    checkout: {
      successMessage: 'Paiement reçu, mise à jour de votre solde...',
      cancelMessage: 'Paiement annulé.'
    }
  },
  creditsModal: {
    title: 'Rechargez vos crédits',
    balance: 'Solde actuel : {count} crédit | Solde actuel : {count} crédits',
    remainingImages: 'de quoi générer environ {count} image | de quoi générer environ {count} images',
    topupTitle: 'Recharge ponctuelle, sans engagement',
    creditsCount: '{count} crédit | {count} crédits',
    imagesApprox: '≈ {count} image | ≈ {count} images',
    costNote: 'Chaque image générée coûte {cost} crédits. Vos crédits n\'expirent pas.',
    subscription: {
      title: 'Abonnement mensuel — 5€/mois',
      pitch: '{credits} crédits crédités chaque mois, soit environ {images} images. Résiliable à tout moment.',
      badge: '+20% de crédits',
      cta: 'S\'abonner — 5€/mois',
      manageCta: 'Gérer mon abonnement'
    },
    accountLink: 'Voir le détail de mon compte et l\'historique de mes crédits'
  },
  notFound: {
    message: 'Page non trouvée'
  },
  support: {
    title: 'Contacter le support',
    subtitle: 'Choisissez un sujet, décrivez votre demande, nous vous répondrons rapidement.',
    categoryTechnical: 'Support technique',
    categoryBilling: 'Facturation et Abonnement',
    categoryIdea: 'Boîte à idées',
    subjectLabel: 'Objet',
    messageLabel: 'Message',
    submit: 'Envoyer',
    sending: 'Envoi...',
    submitError: 'Une erreur est survenue, veuillez réessayer.',
    successMessage: 'Votre message a bien été envoyé, nous vous répondrons rapidement.',
    newTicket: 'Envoyer un autre message'
  },
  admin: {
    title: 'Administration',
    tabStats: 'Statistiques',
    tabUsers: 'Utilisateurs',
    tabSupport: 'Support',
    categoryLabels: {
      technical: 'Support technique',
      billing: 'Facturation et Abonnement',
      idea: 'Boîte à idées'
    },
    stats: {
      freeUsers: 'Utilisateurs gratuits',
      paidUsers: 'Utilisateurs payants',
      totalLogins: 'Connexions totales',
      recentLogins: 'Connexions (7 derniers jours)',
      totalImages: 'Images générées',
      avgPerBatch: 'Moyenne images / génération',
      avgPerUser: 'Moyenne images / utilisateur',
      avgSavedPerFolder: 'Moyenne images sauvegardées / dossier',
      topActive: 'Utilisateurs les plus actifs'
    },
    users: {
      addButton: 'Ajouter un utilisateur',
      editButton: 'Modifier',
      searchPlaceholder: 'Rechercher par email ou nom...',
      email: 'Email',
      name: 'Nom',
      confirmed: 'Confirmé',
      confirmedYes: 'Confirmé',
      confirmedNo: 'Non confirmé',
      admin: 'Admin',
      credits: 'Crédits',
      signIns: 'Connexions',
      subscription: 'Abonnement',
      prevPage: 'Précédent',
      nextPage: 'Suivant',
      saveError: 'Une erreur est survenue.'
    },
    support: {
      allStatuses: 'Tous',
      notesPlaceholder: 'Notes internes...',
      empty: 'Aucun ticket pour le moment.'
    },
    ticketStatus: {
      open: 'Ouvert',
      in_progress: 'En cours',
      resolved: 'Résolu',
      closed: 'Fermé'
    }
  }
}
